import { Box, Flex } from '@chakra-ui/react';
import { Heading, Icon, Text } from 'components/UI';
import { IconType } from 'react-icons/lib';

type SettingsInfoProps = {
  title: string;
  description: string;
  icon: React.ElementType;
};

const SettingsInfo = ({ title, description, icon }: SettingsInfoProps) => (
  <Box p={6} bgColor="base2Colour.500" mb={3}>
    <Flex gap={6} alignItems="center">
      <Icon as={icon as IconType} fontSize={54} color="gray.700" />
      <Box>
        <Heading as="h2" color="gray.700" fontSize="2xl" fontWeight="medium" letterSpacing={1}>
          {title}
        </Heading>
        <Text fontSize={14} color="base2FontColour.500">
          {description}
        </Text>
      </Box>
    </Flex>
  </Box>
);

export default SettingsInfo;
